<template v-if="parsed">
  <v-container fluid class="pa-0">
    <v-container class="pb-0 pt-6">
      <h2>
        {{ headerOneData }}
      </h2>
    </v-container>
  </v-container>
</template>

<script setup>
const props = defineProps({
  headerOne: {
    type: String,
    default: "",
  },
});

const headerOneData = props.headerOne;
let parsed = props.headerOne ? true : false;
</script>
